import { SimpleMuiButton } from '@dreamstack/feature-components'
import { useTranslation } from '@dreamstack/i18n'
import type { FunctionComponent} from 'react';
import { useState } from 'react'
import tw, { styled } from 'twin.macro'
import type { IndexType } from '..'
import { Autocomplete } from './Autocomplete'
import { useSearchContext } from './SearchContext'
import { useAutocompletePlugins } from './useAutocompletePlugins'
const SEARCH_BUTTON_WIDTH = 120

const StyledAutocomplete = styled.div`
  --aa-primary-color-rgb: 80, 128, 144;
  ${tw`flex-1`}
  .aa-Form {
    ${tw`height[56px]`}
    ${tw`bg-accentroGray-50 text-accentroGray-full border-0 rounded-none`}
  }
  .aa-Input {
    ${tw`px-px-16 ml:px-px-24`}
    ${tw`overflow-ellipsis`}
  }
  .aa-InputWrapperPrefix {
    ${tw`hidden`}
  }
  .aa-InputWrapperSuffix {
    ${tw`hidden`}
  }
`

export const SearchAutocomplete: FunctionComponent<React.PropsWithChildren<{
  indexType: IndexType
}>> = ({ indexType }) => {
  const {
    searchState,
    setSearchState,
    submitState,
    resetState,
    autocompleteRef,
  } = useSearchContext()

  const plugins = useAutocompletePlugins({
    indexType: indexType,
    setSearchState,
  })

  const t = useTranslation()

  const [currentQuery, setCurrentQuery] = useState('')

  return (
    <>
      <div tw="flex flex-col space-y-px-16 sm:(flex-row space-y-0 space-x-px-16)">
        <Autocomplete
          autocompleteRef={autocompleteRef}
          placeholder={t('accentro:newsSearch.searchPlaceholder')}
          detachedMediaQuery="none"
          initialState={{
            query: searchState.query,
          }}
          openOnFocus={true}
          onSubmit={submitState}
          onReset={resetState}
          plugins={plugins}
          onStateChange={({ state }) => setCurrentQuery(state.query)}
          getPanelProps={({ props }) => ({
            ...props,
            style: /*css*/ `
              z-index: 1000;
              margin-right: -${SEARCH_BUTTON_WIDTH + 6}px;
              --aa-primary-color-rgb: 80, 128, 144;
              --aa-icon-color-rgb: 43, 45, 54;
              --aa-icon-color-alpha: 1;
              /* default: --aa-muted-color-rgb: 128,126,163; --aa-muted-color-alpha: 0.6; */
              --aa-muted-color-rgb: 80, 128, 144;
              --aa-muted-color-alpha: 0.6;
              --aa-panel-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.25);
              border-radius: 0;
            `,
          })}
          StyledDiv={StyledAutocomplete}
        />
        <SimpleMuiButton
          variant={indexType === 'news' ? 'contained' : 'outlined'}
          color={indexType === 'news' ? 'primary' : 'default'}
          onClick={() => {
            submitState({ state: { query: currentQuery } })
          }}
          style={{ width: SEARCH_BUTTON_WIDTH }}
          size="small"
        >
          {t('accentro:newsSearch.searchAction')}
        </SimpleMuiButton>
      </div>
    </>
  )
}
